import { Play } from "lucide-react";
import { imgSrc } from "@/lib/api";

export function EpisodeCard({ episode, large = false, onPlay }) {
  return (
    <button
      onClick={() => onPlay && onPlay(episode)}
      data-testid={`episode-card-${episode.id}`}
      className="group relative block w-full text-left overflow-hidden bg-slate-900"
    >
      <div className={`${large ? "aspect-[16/10]" : "aspect-video"} overflow-hidden`}>
        <img
          src={imgSrc(episode.thumbnail)}
          alt={episode.title}
          className="img-zoom h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent" />
      <div className="absolute top-4 left-4">
        <span className="bg-white/95 text-slate-900 text-[10px] tracking-[0.2em] uppercase font-bold px-3 py-1.5">
          {episode.kind}
        </span>
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-7 flex items-end justify-between gap-4">
        <div className="min-w-0">
          <h3
            className={`font-display font-bold text-white leading-tight ${
              large ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"
            }`}
          >
            {episode.title}
          </h3>
          {large && episode.description && (
            <p className="mt-2 text-white/70 text-sm max-w-md line-clamp-2">{episode.description}</p>
          )}
        </div>
        <span className="shrink-0 h-11 w-11 sm:h-12 sm:w-12 rounded-full bg-pool flex items-center justify-center text-white transition-transform duration-300 group-hover:scale-110">
          <Play className="h-5 w-5 ml-0.5" />
        </span>
      </div>
    </button>
  );
}
